export default "__VITE_ASSET__Biu2mCQR__"